document.addEventListener("DOMContentLoaded", function () {
  initWimNewsletterForm();
});

function initWimNewsletterForm() {
  const form = document.querySelector('.wim-helium-newsletter');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(form);
    const values = {};

    for (const [key, value] of formData.entries()) {
      values[key] = value;
    }

    if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {
      klaviyo.push(['identify', {
        $email: values.email,
        'Birthday': values.birthday
      }]);
    }
  });
}